import { menuIcon } from '../../../../configs/Icons';

const pathLinks = [
    {
        id: 1,
        path: 'dashboard',
        title: 'dashboard',
        iconWL: menuIcon.dashboardWL,
        iconWF: menuIcon.dashboardWF,
        reqPermission: ''
    },
    // {
    //     id: 2,
    //     path: 'admins',
    //     title: 'admins',
    //     iconWL: menuIcon.adminWL,
    //     iconWF: menuIcon.adminWF,
    //     reqPermission: 'admin.manager.view'
    // },
    {
        id: 2,
        path: 'agency',
        title: 'agency & customer',
        iconWL: menuIcon.clientsWL,
        iconWF: menuIcon.clientsWF,
        reqPermission: 'admin.customer.view'
    },
    // {
    //     id: 3,
    //     path: 'customers',
    //     title: 'agency & customers',
    //     iconWL: menuIcon.clientsWL,
    //     iconWF: menuIcon.clientsWF,
    //     reqPermission: 'admin.customer.view'
    // },
    {
        id: 4,
        path: 'subscriptions',
        title: 'subscriptions',
        iconWL: menuIcon.applicationWL,
        iconWF: menuIcon.applicationWF,
        subMenu: [
            {
                id: 41,
                path: 'subscriptions/manage',
                title: 'manage',
                reqPermission: 'admin.subscription.view'
            },
            {
                id: 42,
                path: 'subscriptions/pending',
                title: 'pending',
                reqPermission: 'admin.subscription.create'
            }
        ]
    },
    {
        id: 5,
        path: 'services',
        title: 'services',
        iconWL: menuIcon.serviceWL,
        iconWF: menuIcon.serviceWF,
        subMenu: [
            {
                id: 51,
                path: 'services/manage',
                title: 'manage',
                reqPermission: 'admin.subscription.view'
            },
            {
                id: 52,
                path: 'services/pending',
                title: 'pending',
                reqPermission: 'admin.subscription.create'
            }
        ]
    },
    {
        id: 6,
        path: 'billing',
        title: 'billing',
        iconWL: menuIcon.billingWL,
        iconWF: menuIcon.billingWF,
        subMenu: [
            {
                id: 61,
                path: 'billing/invoices',
                title: 'invoices',
                reqPermission: 'admin.finance.invoice.view'
            },
            {
                id: 62,
                path: 'billing/quotations',
                title: 'quotations',
                reqPermission: 'admin.finance.quotation.view'
            },
            {
                id: 63,
                path: 'billing/transactions',
                title: 'transactions',
                reqPermission: 'admin.finance.transaction.view'
            },
            {
                id: 64,
                path: 'billing/unauthorized',
                title: 'unauthorized invoices',
                reqPermission: 'admin.finance.invoice.view'
            }
        ]
    },
    {
        id: 7,
        path: 'support-ticket',
        title: 'support ticket',
        iconWL: menuIcon.supportWL,
        iconWF: menuIcon.supportWF,
        reqPermission: 'admin.support.ticket.view'
    },
    {
        id: 8,
        path: 'reports',
        title: 'reports',
        iconWL: menuIcon.reportsWL,
        iconWF: menuIcon.reportsWF,
        subMenu: [
            {
                id: 81,
                path: 'reports/sales',
                title: 'Sales',
                reqPermission: 'admin.report.sales'
            },
            {
                id: 82,
                path: 'reports/forecast',
                title: 'Forecast',
                reqPermission: 'admin.report.forecast'
            },
            {
                id: 83,
                path: 'reports/other',
                title: 'Other',
                reqPermission: 'admin.report.others'
            }
        ]
    },
    {
        id: 9,
        path: 'settings',
        title: 'settings',
        iconWL: menuIcon.settingsWL,
        iconWF: menuIcon.settingsWF,
        subMenu: [
            {
                id: 91,
                path: 'settings/basic',
                title: 'basic',
                reqPermission: 'admin.settings.basic.view'
            },
            {
                id: 92,
                path: 'settings/static',
                title: 'static',
                reqPermission: 'admin.settings.static.view'
            },
            {
                id: 93,
                path: 'settings/invoice',
                title: 'invoice config',
                reqPermission: ''
            },
            {
                id: 97,
                path: 'settings/admins',
                title: 'admins',
                reqPermission: 'admin.manager.view'
            },
            {
                id: 94,
                path: 'settings/products',
                title: 'products',
                reqPermission: 'admin.settings.product.view'
            },
            {
                id: 95,
                path: 'settings/services',
                title: 'services',
                reqPermission: ''
            },
            {
                id: 96,
                path: 'settings/auth-manage',
                title: 'Auth Manage',
                reqPermission: 'admin.settings.auth.view'
            }
        ]
    },
    {
        id: 10,
        path: 'logs',
        title: 'logs',
        iconWL: menuIcon.logsWL,
        iconWF: menuIcon.logsWF,
        subMenu: [
            { id: 101, path: 'logs/files', title: 'Files', reqPermission: 'admin.logs.view' },
            {
                id: 102,
                path: 'logs/external',
                title: 'External Logs',
                reqPermission: 'admin.logs.view'
            }
        ]
    },

    {
        id: 11,
        path: 'api',
        title: 'API',
        iconWL: menuIcon.apisWL,
        iconWF: menuIcon.apisWF,
        subMenu: [
            { id: 111, path: 'api/list', title: 'List', reqPermission: 'developer.api.view' },
            {
                id: 112,
                path: 'api/access-token',
                title: 'Access Token',
                reqPermission: 'developer.api.view'
            }
        ]
    },
    {
        id: 12,
        path: 'documentation',
        title: 'documentation',
        iconWL: menuIcon.documentationWL,
        iconWF: menuIcon.documentationWF,
        reqPermission: ''
    }
];

export default pathLinks;
